import { Injectable, EventEmitter, HostListener, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ISliderWebData } from '@app/models/slider.model';
import { FavoriesPipe } from '@app/pipes/favories.pipe';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class UiHelper {
  favPreMatches = [];
  favPreMatchesListener: EventEmitter<any> = new EventEmitter();
  constructor(private _snackBar: MatSnackBar, public _Router: Router) {
    this.getQuickTipp();
    this.getAcceptOdds();
    this.darkThemeListener.pipe(debounceTime(500)).subscribe(() => {
      this.navbarDarkThemeState = false;
      this.changeTheme();
    });
    const a = localStorage.getItem('_FavoritesPreMatch');
    if (a != null) {
      this.favPreMatches = JSON.parse(a);
    }
  }

  darkThemeListener: EventEmitter<any> = new EventEmitter();
  navbarDarkThemeState = false;

  quickTippIsActive = true;
  tabSelected = 1;

  leftMenuListener: EventEmitter<any> = new EventEmitter();
  leftMenu = false;
  rightMenuListener: EventEmitter<any> = new EventEmitter();
  rightMenu = false;

  // For bet3000's right area view toogle operations
  rightAreaListener: EventEmitter<any> = new EventEmitter();
  rightArea = false;

  forgotPassListener: EventEmitter<any> = new EventEmitter();
  forgotPass = false;

  leftSportsMenuDialogListener: EventEmitter<any> = new EventEmitter();
  leftSportsMenuDialog = false;

  loadingDialogListener: EventEmitter<any> = new EventEmitter();
  loadingDialog = false;

  loadingTicketDialogListener: EventEmitter<any> = new EventEmitter();
  loadingTicketDialog = false;

  languageChangerDialogListener: EventEmitter<any> = new EventEmitter();
  consentScreenDialogListener: EventEmitter<any> = new EventEmitter();

  languageChangerDialog = false;

  bottomNavbarNavigate = 1;
  bottomNavbarNavigateListener: EventEmitter<any> = new EventEmitter();

  windowsWidth = 0;
  windowsHeight = 0;
  windowResized: EventEmitter<any> = new EventEmitter();

  documentScrollPX = 0;
  documentScrollListener: EventEmitter<any> = new EventEmitter();

  navbarElemList = [];
  contentElemList = [];
  contentHeight = 0;
  contentHeightListener: EventEmitter<any> = new EventEmitter();

  contentMarginTop = 0;
  contentMarginTopListener: EventEmitter<any> = new EventEmitter();

  currentRoute = '';
  currentRouteListener: EventEmitter<any> = new EventEmitter();

  favTournaments = [];
  favTournamentListener: EventEmitter<any> = new EventEmitter();

  navbarTitle = {
    s: '',
    isRaw: false,
    show: true,
  };
  navbarTitleListener: EventEmitter<any> = new EventEmitter();

  refreshAppListener: EventEmitter<any> = new EventEmitter();

  selectedSlipDetailListener: EventEmitter<any> = new EventEmitter();
  selectedSlipDetail = 0;
  slips_selectedSlipType = 0;
  slips_selectedYear = 0;
  slips_selectedMonth = 0;

  // B3000
  userProfileList;
  sportSearchInputActive = false;
  footerIsActive = true;
  leftMenuState = false;
  rightMenuState = false;
  loginDropDownIsOpen = false;
  shopDropDownIsOpen = false;
  tabsMenuIsOpen = false;
  langDropdownIsOpen = false;
  leftMenuIsOpen = false;
  changeThemeListener: EventEmitter<any> = new EventEmitter();
  currentTheme = 'theme-light';
  placedBetMessage = false;
  placeBetIsActive = false;
  isLugasErrorActive = false;
  isLugasError5minute = false;

  flagRefreshCurrentSlip = true;
  insicStatus: number;

  leftMenuSportSelectedListener: EventEmitter<any> = new EventEmitter();

  isTabActive = true;
  isTabActiveTimeout: any;
  isTabActiveLastChanges: any;
  isTabActiveListener: EventEmitter<any> = new EventEmitter();

  isActiveSignalrConnection = false;
  isActiveSignalrConnectionListener: EventEmitter<any> = new EventEmitter();

  // Single = 0 , Multiple = 1, System = 2;
  currentSlipTabSelected: 0 | 1 | 2 = 1;
  currentSlipTabSelectedListener: EventEmitter<any> = new EventEmitter();

  // Bet Slip = 1 , My bets a.k.a Cashout = 2;
  currentSlipHeaderTabSelected = 1;
  currentSlipHeaderTabSelectedListener: EventEmitter<any> = new EventEmitter();

  accountMobileState = false;
  accountMobileMenu = 0;
  //#endregion
  // Bottom-Dialog
  bottomDialogState = false;
  bottomDialogStateListener: EventEmitter<any> = new EventEmitter();

  // MatchDetailDialog
  detailDialogState = false;

  // B3000
  // match-detail-dialog
  matchDetailData = { matchId: 0, isLive: false };
  matchDetailDataListener: EventEmitter<any> = new EventEmitter();

  allSportSelectedMenuId = '';

  // current-slip-core
  checkboxAcceptOdds = true;

  viewportConst: { [viewportKey: string]: number } = {
    xs: 1,
    s: 3,
    m: 5,
    l: 7,
    xl: 9,
    xxl: 11,
  };

  responsiveResolution = 0;
  responsiveResolutionListener: EventEmitter<number> = new EventEmitter<number>();

  homeSelectedTab = 'hightlights';
  homeSelectedTabListener: EventEmitter<string> = new EventEmitter<string>();

  sliderWebData: Array<ISliderWebData> = [];
  sliderMobileData = [];

  setResolution(_w: number, _h: number) {
    this.windowsWidth = _w;
    this.windowsHeight = _h;
    const data = {
      w: _w,
      h: _h,
    };
    this.windowResized.emit(data);
  }

  setLeftMenu(): void {
    if (this.leftMenu) {
      this.leftMenuListener.emit(false);
      this.leftMenu = false;
    } else {
      this.leftMenuListener.emit(true);
      this.leftMenu = true;
    }
  }

  setRightMenu(): void {
    if (this.rightMenu) {
      this.rightMenuListener.emit(false);
      this.rightMenu = false;
    } else {
      this.rightMenuListener.emit(true);
      this.rightMenu = true;
    }
  }

  changeStatusRightMenu(value): void {
    this.rightMenu = value;
    this.rightMenuListener.emit(value);
  }

  changeStatusRightArea(value): void {
    this.rightArea = value;
    this.rightAreaListener.emit(value);
  }

  closeAllMenus() {
    // //console.log('---.closeAllMenus--------------',this.rightMenu);
    this.leftMenuListener.emit(false);
    this.leftMenu = false;
    this.rightMenuListener.emit(false);
    this.rightMenu = false;
    this.leftSportsMenuDialogListener.emit(false);
    this.leftSportsMenuDialog = false;
  }

  setBottomNavbarNavigate(e) {
    this.bottomNavbarNavigateListener.emit(e);
    this.bottomNavbarNavigate = e;
  }

  setLeftSportsMenuDialog(e) {
    //// console.log("setLeftSportsMenuDialog",e);
    this.leftSportsMenuDialogListener.emit(e);
    this.leftSportsMenuDialog = e;
  }

  setLoadingDialog(e) {
    this.loadingDialogListener.emit(e);
    this.loadingDialog = e;
  }

  setLoadingTicketDialog(e) {
    this.loadingTicketDialogListener.emit(e);
    this.loadingTicketDialog = e;
  }

  setLanguageChangerDialog(e) {
    this.languageChangerDialogListener.emit(e);
    this.languageChangerDialog = e;
  }

  setRefreshApp() {
    this.refreshAppListener.emit(true);
  }

  setDocumentScrollPX(e) {
    this.documentScrollListener.emit(e);
    this.documentScrollPX = e;
  }

  setNavbarElemList(e) {
    this.navbarElemList = e;
  }

  setContentElemList(e) {
    this.contentElemList = e;
  }

  setContentHeight(e) {
    this.contentHeight = e;
  }

  setContentMarginTop(e) {
    this.contentMarginTop = e;
    this.contentMarginTopListener.emit(this.contentMarginTop);
  }

  setCurrentRoute(e) {
    //// console.log(e);
    this.currentRoute = e;
    this.currentRouteListener.emit(e);
  }

  setNavbarTitle(e: string, isRAW?: boolean, isShow = true) {
    this.navbarTitle = {
      s: e,
      isRaw: isRAW,
      show: isShow,
    };
    this.navbarTitleListener.emit(this.navbarTitle);
  }

  fireSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, action, {
        duration: 5000,
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  errorSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, 'X', {
        duration: 5000,
        panelClass: ['snackbar-custom', 'error-snackbar'],
        verticalPosition: 'bottom',
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  successSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, 'X', {
        duration: 5000,
        panelClass: ['snackbar-custom', 'success-snackbar'],
        verticalPosition: 'bottom',
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  warningSnackBar(msg, action, navigateString?) {
    this._snackBar
      .open(msg, action, {
        duration: 5000,
        panelClass: ['snackbar-custom', 'warning-snackbar'],
      })
      .afterDismissed()
      .subscribe(x => {
        // todo Navigate Yapılandırılmalı.
      });
  }

  errorSnackBarWithAction(msg, action, navigateString?) {
    this._snackBar
      .open(msg, action, {
        duration: 5000,
        panelClass: ['snackbar-custom', 'error-snackbar'],
        verticalPosition: 'bottom',
      })
      .onAction()
      .subscribe(x => {
        window.open(navigateString, '_blank');
        // this._Router.navigate(["https://help-center.bet3000.de/"])
        // todo Navigate Yapılandırılmalı.
      });
  }
  errorSnackBarWithOpenAccountTab(msg, action, accountTab) {
    this._snackBar
      .open(msg, action, {
        duration: 50000,
        panelClass: ['snackbar-custom', 'error-snackbar', 'underline-text'],
        verticalPosition: 'bottom',
      })
      .onAction()
      .subscribe(x => {
        this.b3000SetAcountMobileState('open', accountTab);
      });
  }

  favTournamentChanged(e) {
    const selectedTournament = this.favTournaments.filter(k => k.tourid.toString() == e.tourid.toString());

    if (selectedTournament.length > 0) {
      // this.favTournaments.splice(selectedTournament, 1);
      this.favTournaments = this.favTournaments.filter(k => k.tourid.toString() != e.tourid.toString());
    } else {
      this.favTournaments.push(e);
    }

    this.favTournamentListener.emit(this.favTournaments);
  }

  favPreMatchChanged(matchItem) {
    const a = localStorage.getItem('_FavoritesPreMatch');
    if (a != null) {
      this.favPreMatches = JSON.parse(a);
    }

    if (this.favPreMatches.filter(i => i.BetradarMatchId === matchItem.BetradarMatchId).length > 0) {
      this.favPreMatches = this.favPreMatches.filter(i => i.BetradarMatchId !== matchItem.BetradarMatchId);
    } else {
      this.favPreMatches.push(matchItem);
    }
    localStorage.setItem('_FavoritesPreMatch', JSON.stringify(this.favPreMatches));

    const x = new FavoriesPipe();
    x.transform(matchItem);

    this.favPreMatchesListener.emit(this.favPreMatches);
  }

  reBuildFavoriList(matchItem) {
    const a = localStorage.getItem('_FavoritesPreMatch');
    if (a != null) {
      this.favPreMatches = JSON.parse(a);
    }

    if (this.favPreMatches.filter(i => i.BetradarMatchId === matchItem.BetradarMatchId).length > 0) {
      this.favPreMatches = this.favPreMatches.filter(i => {
        return i.BetradarMatchId === matchItem.BetradarMatchId;
      });
    } else {
      this.favPreMatches.push(matchItem);
    }
    localStorage.setItem('_FavoritesPreMatch', JSON.stringify(this.favPreMatches));

    const x = new FavoriesPipe();
    x.transform(matchItem);

    this.favPreMatchesListener.emit(this.favPreMatches);
  }
  setFooterState(state) {
    this.footerIsActive = state;
  }

  b3000SetRightMenuState(state = '') {
    if (state == '') {
      this.rightMenuState = false;
      document.getElementById('rightSidenav').style.width = '0';
    } else if (state == 'open') {
      this.b3000SetBottomDialogState('close');
      this.rightMenuState = true;
      document.getElementById('rightSidenav').style.width = '75%';
    } else if (state == 'close') {
      this.rightMenuState = false;
      document.getElementById('rightSidenav').style.width = '0';
    } else {
      this.rightMenuState = false;
      document.getElementById('rightSidenav').style.width = '0';
    }
  }

  b3000SetLeftMenuState(state = '') {
    if (state == '') {
      this.leftMenuState = false;
      document.getElementById('leftSidenav').style.width = '0';
    } else if (state == 'open') {
      this.b3000SetBottomDialogState('close');
      this.leftMenuState = true;
      document.getElementById('leftSidenav').style.width = '75%';
    } else if (state == 'close') {
      this.leftMenuState = false;
      document.getElementById('leftSidenav').style.width = '0';
    } else {
      this.leftMenuState = false;
      document.getElementById('leftSidenav').style.width = '0';
    }
  }

  getTheme() {
    return this.currentTheme;
  }
  changeTheme() {
    if (this.currentTheme == 'theme-dark') {
      this.currentTheme = 'theme-light';
      const bodyElement = document.getElementsByTagName('body');
      if (bodyElement && bodyElement.length > 0) {
        bodyElement[0].classList.remove(localStorage.getItem('themeState'));
        bodyElement[0].classList.add('theme-light');
      }
    } else {
      this.currentTheme = 'theme-dark';
      const bodyElement = document.getElementsByTagName('body');
      if (bodyElement && bodyElement.length > 0) {
        bodyElement[0].classList.remove(localStorage.getItem('themeState'));
        bodyElement[0].classList.add('theme-dark');
      }
    }

    localStorage.setItem('themeState', this.currentTheme);
  }

  tabsTitleChange(tabId: number) {
    this.tabSelected = tabId;
  }

  toogleForgotPass() {
    this.b3000SetRightMenuState('close');

    this.forgotPass = !this.forgotPass;
    this.forgotPassListener.emit(this.forgotPass);
  }

  setAccountDesktopState(selectMenu = 1) {
    if (this.tabsMenuIsOpen === false) {
      this.openShowTabsMenu();
    }
    if (selectMenu) {
      this.tabsTitleChange(selectMenu);
    }
  }

  b3000SetAcountMobileState(state = '', selectMenu = 1, selectedSlip = 0) {
    const ismobile = this.windowsWidth < 990 ? true : false;
    this.accountMobileMenu = selectMenu;
    this.selectedSlipDetail = selectedSlip;
    if (ismobile) {
      if (document.getElementById('accountMobile') == null) {
        return;
      }

      this.accountMobileMenu = selectMenu;
      this.selectedSlipDetail = selectedSlip;
      if (state == '') {
        this.accountMobileState = false;
        document.getElementById('accountMobile').style.top = '100%';
        document.getElementById('accountMobile').style.height = '0';
      } else if (state == 'open') {
        this.selectedSlipDetailListener.emit(this.selectedSlipDetail);
        this.accountMobileState = true;
        document.getElementById('accountMobile').style.top = '60px';
        document.getElementById('accountMobile').style.height = 'calc(var(--vh) - 60px)';
      } else if (state == 'close') {
        this.accountMobileState = false;
        if (document.getElementById('accountMobile') != null) {
          document.getElementById('accountMobile').style.top = '100%';
          document.getElementById('accountMobile').style.height = '0';
        }
      } else {
        this.accountMobileState = false;
        if (document.getElementById('accountMobile') != null) {
          document.getElementById('accountMobile').style.top = '100%';
          document.getElementById('accountMobile').style.height = '0';
        }
      }
    } else {
      if (state == '' || state == 'close') {
        this.closeShowTabsMenu();
        return;
      } else {
        if (state == 'open') {
          this.selectedSlipDetailListener.emit(this.selectedSlipDetail);
          this.setAccountDesktopState(selectMenu);
        } else {
          if (document.getElementById('accountDesktop') != null) {
            document.getElementById('accountDesktop').style.top = '100%';
            document.getElementById('accountDesktop').style.height = '0';
          }
        }
      }
    }
  }
  openVerificationSow() {
    let selectMenu = 11;
    const ismobile = this.windowsWidth < 990 ? true : false;
    if (!ismobile) {
      this.setAccountDesktopState(selectMenu);
    } else {
      this.accountMobileMenu = selectMenu;
      if (document.getElementById('accountMobile') == null) {
        return;
      }

      document.getElementById('accountMobile').style.top = '60px';
      document.getElementById('accountMobile').style.height = 'calc(var(--vh) - 60px)';
    }
  }
  closeDimmer() {
    if (document.getElementById('dimmer') != null) {
      document.getElementById('dimmer').style.position = 'static';
    }
    this.loginDropDownIsOpen = false;
    this.shopDropDownIsOpen = false;
    this.langDropdownIsOpen = false;
    this.leftMenuIsOpen = false;
    this.closeShowTabsMenu();
  }

  leftMenuOpen() {
    this.leftMenuIsOpen = !this.leftMenuIsOpen;
  }

  loginDropDownOpen() {
    this.loginDropDownIsOpen = !this.loginDropDownIsOpen;
  }

  shopDropDownOpen() {
    this.shopDropDownIsOpen = !this.shopDropDownIsOpen;
  }

  openShowTabsMenu() {
    // account modal açmak için bu fonksiyonu kullanıyoruz
    const bodyElement = document.body;
    bodyElement.classList.add('no-scroll');
    this.tabsMenuIsOpen = true;
  }

  closeShowTabsMenu() {
    // account modal kapatmak için bu fonksiyonu kullanıyoruz
    const bodyElement = document.body;
    bodyElement.classList.remove('no-scroll');
    this.tabsMenuIsOpen = false;
  }

  langDropdownOpen() {
    this.langDropdownIsOpen = !this.langDropdownIsOpen;
  }

  //#endregion
  // Bottom-Dialog
  b3000SetBottomDialogState(state = '') {
    this.placedBetMessage = false;
    this.placeBetIsActive = false;
    const element = document.getElementById('bottomDialog');

    if (element === null || element === undefined) {
      return;
    }
    if (state === '') {
      this.bottomDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    } else if (state === 'open') {
      this.bottomDialogState = true;
      element.style.top = '60px';
      element.style.height = 'calc(var(--vh) - 120px)';
    } else if (state === 'close') {
      this.bottomDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    } else {
      this.bottomDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    }
    this.bottomDialogStateListener.emit(this.bottomDialogState);
  }

  b3000SetMatchDetailDialog(state = '') {
    //  this.placedBetMessage = false;
    //  this.placeBetIsActive = false;
    const element = document.getElementById('detailDialog');

    if (element === null || element === undefined) {
      return;
    }

    if (state === '') {
      this.detailDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    } else if (state === 'open') {
      this.detailDialogState = true;
      element.style.top = '60px';
      element.style.height = 'calc(var(--vh) - 120px)';
    } else if (state === 'close') {
      this.detailDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';

      // Match Detail Dialog içindeki Componentler ( eventdetail - liveeventetail ) Temizleniyor.
      this.setMatchDetailData(0, false);
    } else {
      this.detailDialogState = false;
      element.style.top = '100%';
      element.style.height = '0';
    }
  }

  setSportInputStatus(status) {
    this.sportSearchInputActive = status;
  }

  getQuickTipp() {
    const q = JSON.parse(localStorage.getItem('quickTipp'));
    if (q !== null) {
      this.quickTippIsActive = q;
      return q;
    } else {
      this.setQuickTipp(true);
      return true;
    }
  }

  changeQuickTipp() {
    const q = JSON.parse(localStorage.getItem('quickTipp'));
    if (q !== null) {
      this.setQuickTipp(!q);
    }
  }

  setQuickTipp(value) {
    this.quickTippIsActive = value;
    localStorage.setItem('quickTipp', JSON.stringify(value));
  }

  leftMenuSportSelected(_sportID) {
    this.leftMenuSportSelectedListener.emit(_sportID);
  }

  setInsicStatus(value) {
    this.insicStatus = value;
  }

  setMatchDetailData(matchId = 0, isLive = false) {
    this.matchDetailData = { matchId, isLive };
    this.matchDetailDataListener.emit(this.matchDetailData);
  }

  ScrollToTop() {
    // let scrollcord;
    // scrollcord = document.getElementsByTagName('body')[0];
    // if (scrollcord != null) {
    //   scrollcord.scrollIntoView({
    //     // behavior: "smooth",
    //   });
    // }
    const elementList = document.querySelectorAll('#main-page');
    if (elementList && elementList.length > 0) {
      const element = elementList[0] as HTMLElement;
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }

  ScrollToId() {
    let scrollcord;
    scrollcord = document.getElementById(this.allSportSelectedMenuId);
    if (scrollcord != null) {
      scrollcord.scrollIntoView({
        // behavior: "smooth",
      });
    }
  }

  // current-slip-core
  getAcceptOdds() {
    const acceptOdds = JSON.parse(localStorage.getItem('acceptOdds'));
    if (acceptOdds == null) {
      localStorage.setItem('acceptOdds', JSON.stringify(true));
      this.checkboxAcceptOdds = true;
    } else {
      this.checkboxAcceptOdds = acceptOdds;
    }
  }

  setAcceptOdds(e) {
    this.checkboxAcceptOdds = e.target.checked;
    localStorage.setItem('acceptOdds', JSON.stringify(e.target.checked));
  }

  setIsTabActive(state: boolean, time: number) {
    if (time - this.isTabActiveLastChanges < 5 * 1000) {
      if (this.isTabActive) {
        clearTimeout(this.isTabActiveTimeout);
      }
      this.isTabActiveTimeout = setTimeout(() => {
        this.setIsActiveSignalrConnection(state);
      }, 2000);
    } else {
      this.setIsActiveSignalrConnection(state);
    }
    this.isTabActiveLastChanges = time;
    this.isTabActiveListener.emit(this.isTabActive);
  }

  setIsActiveSignalrConnection(state: boolean): void {
    this.isActiveSignalrConnection = state;
    this.isActiveSignalrConnectionListener.emit(this.isActiveSignalrConnection);
  }

  setCurrentSlipTabSelected(state: 0 | 1 | 2) {
    this.currentSlipTabSelected = state;
    this.currentSlipTabSelectedListener.emit(this.currentSlipTabSelected);
  }

  /**
   * Set Current Header Tab on bet slip & my Bets screen. This is use for desktop version.
   *
   * @param state 1|2 - The first input number
   * @returns void
   */
  setCurrentSlipHeaderTabSelected(state: number) {
    this.currentSlipHeaderTabSelected = state;
    this.currentSlipHeaderTabSelectedListener.emit(this.currentSlipHeaderTabSelected);
  }

  setResponsiveResolution(viewport: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl') {
    console.log('setResponsiveResolution', viewport);
    this.responsiveResolution = this.viewportConst[viewport];
    this.responsiveResolutionListener.emit(this.responsiveResolution);
  }

  isResponsiveRules(viewport: Array<'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'>) {
    return viewport.filter(value => this.responsiveResolution >= this.viewportConst[value]).length > 0;
  }
}
